import { IRouteConfig } from '@/router/types';

export default [
  {
    path: '/template',
    name: 'Template',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/template/list',
    meta: {
      title: '模版',
    },

    children: [
      {
        path: 'list',
        name: 'TemplateList',
        component: () => import('./template-module/views/list/index.vue'),
        meta: {
          title: '列表模板',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: 'components',
        name: 'TemplateComponents',
        component: () => import('./template-module/views/components/index.vue'),
        meta: {
          title: '组件Demo',
          auth: true,
          isKeepAlive: true,
        },
      },
    ],
  },
  {
    path: '/keep-alive',
    name: 'KeepAlive',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/configuration-manage/data-permissions/list',
    meta: {
      title: '模版',
      auth: true,
    },
    children: [
      {
        path: 'page1',
        name: 'KeepAlivePage1',
        component: () => import('./keep-alive/views/page1.vue'),
        meta: {
          title: 'KeepAlive页面1',
          auth: true,
          isKeepAlive: true,
        },
      },
      {
        path: 'page2',
        name: 'KeepAlivePage2',
        component: () => import('./keep-alive/views/page2.vue'),
        meta: {
          title: 'KeepAlive页面2',
          auth: true,
          isKeepAlive: true,
          activeMenu: 'KeepAlivePage1'
        },
      },
      {
        path: 'page3/:id',
        name: 'KeepAlivePage3',
        component: () => import('./keep-alive/views/page3.vue'),
        meta: {
          title: 'KeepAlive页面3',
          auth: true,
          isKeepAlive: true,
        },
      },
    ],
  },
  {
    path: '/webview',
    name: 'Webview',
    component: () => import('@/layouts/main/index.vue'),
    redirect: '/webview/list',
    meta: {
      title: 'webview',
      auth: true,
    },
    children: [
      {
        path: 'list',
        name: 'WebviewList',
        component: () => import('./webview/views/list.vue'),
        meta: {
          title: 'webview页面',
          auth: true,
          isKeepAlive: true,
        },
      },
    ],
  },
] as IRouteConfig[];
